const gridSize = [151, 151]
const taxRate = 12 * 0.01  // per year

const address = "0xA70e070C350F97200CA28F9FBe0Dc85c2c8ca79E"

export {
    gridSize,
    taxRate,
    address,
}